import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';
//import { saveAuction, getAuctions, saveTradeSession } from '../../Api';
import Moment from 'react-moment';//Both are required here
import moment from 'moment'; //Both are required here
//import useApi from '../../api/useApi'
import { de } from 'date-fns/esm/locale';
import logo from '../images/sb-logo.png';
import axios from '../api/axios';
import boltwareLogo from '../images/BoltwareLogo2.png';

const Poolings = () => {
    const navigate = useNavigate();
    const [auctions, setAuctions] = useState([]);

    const loadAuctions = async () => {
        try {
           // const response = await axios.get('https://localhost:44495/api/auth/getUpcomingAuctions', {
               const response = await axios.get('https://eauctionspicesboard.in/api/auth/getUpcomingAuctions', {
            }, {
                withCredentials: true
            });
            if (response?.data) {
                setAuctions(response?.data)
            }

        } catch (error) {

            if (!error?.response)
                console.error('No Server Response');
        }
    }


    useEffect(() => {
        loadAuctions();
    }, []);


    const viewPoolingDetail = (auctionId) => {
        navigate(`/poolingDetails/${auctionId}`);
    };

    return (
        <div className="horizontalmenu" style={{height:'98vh'} }>
            <div className="inner-body main-container container">

                <div className="page-header mobile-header">

                    <img src={logo} className="header-brand-img text-center mb-4 d-block d-md-none" style={{ maxWidth: "60%", margin: 'auto' }} alt="logo" />

                    <div>
                        <h2 className="main-content-title tx-24 mg-b-5">Upcoming Auctions</h2>
                        <h6>Details of Scheduled Auctions for which online Pooling has closed.</h6>
                    </div>

                    <img src={logo} className="header-brand-img mb-4 d-none d-md-block" style={{ maxWidth: "15%" }} alt="logo" />

                </div>
                <div className="row row-sm">
                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
                        <div className="card custom-card">
                            {/*<div className="card-header border-bottom-0 pb-0">*/}
                            {/*    <h6 class="main-content-label mb-1">Basic DataTable</h6>*/}
                            {/*    <p class="text-muted card-sub-title">Searching, ordering and paging goodness will be immediately added to the table, as shown in this example.</p>*/}
                            {/*</div>*/}
                            <div className="card-body">
                                <div className="table-responsive border border-bottom-0 ">
                                    <table className="table table-hover table-striped  table-vcenter   mb-0">
                                        <thead>
                                            <tr>
                                                <th className="wd-lg-4p text-center"><span>#</span></th>
                                                <th className="min-w-240"><span>Auctioneer</span></th>
                                                <th className="wd-lg-20p text-center"><span>Auction Number</span></th>
                                                <th className="wd-lg-20p text-center"><span>Auction Date</span></th>
                                                <th className="wd-lg-20p text-center"><span>Start Time</span></th>
                                                <th className="wd-lg-20p text-center text-nowrap"><span>End Time</span></th>
                                                <th className="wd-lg-20p text-center ">Pooled Lots</th>
                                            </tr>
                                        </thead>
                                        <tbody className="custom-hover-table  text-nowrap">
                                            {auctions.map((auc, index) => {
                                                return <tr>
                                                    <td className="text-center"> {index + 1}
                                                    </td>
                                                    <td style={{ maxWidth: "600px", overflowX: "hidden" }}>
                                                         {auc.companyName.substring(0, 60)}...
                                                    </td>
                                                    <td className="text-center"> {auc.auctionNo} </td>
                                                    <td className="text-center"><Moment format="DD-MMM-YYYY">{auc.auctionDate}</Moment>   </td>
                                                   
                                                    <td className="text-center">
                                                        {auc.startTime ? <Moment format="LT">{auc.startTime}</Moment> : null}
                                                       
                                                    </td>
                                                    <td className="text-center ">
                                                        {auc.endTime ? <Moment format="LT">{auc.endTime}</Moment> : null}
                                                       
                                                    </td>
                                                    <td className="text-center">
                                                        <button className="btn ripple btn-outline-primary mg-b-4  pd-x-10 mg-r-5 btn-sm" type="button" onClick={() => viewPoolingDetail(auc.auctionId)}>
                                                            View Pooling Detail
                                                        </button></td>

                                                </tr>
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row row-sm fixed-bottom m-5">
                    <div className="d-none d-md-block" style={{ textAlign: 'right' }}>
                        <div className="d-flex p-4 flex-column justify-content-center text-right">
                            <div className="tx-13 text-muted">Software Developed & maintained by </div>
                            <div>  <img src={boltwareLogo} alt="boltware" style={{ width: "10%" }}></img></div>
                            <a href="https://boltware.in" rel="noreferrer" className="tx-12" target="_blank">www.boltware.in</a>
                        </div>
                    </div>

                    <div className=" d-block d-md-none">
                        <div className="d-flex p-4 flex-column justify-content-center text-center">
                            <div className="tx-13 text-muted">Software Developed & maintained by </div>
                            <div>  <img src={boltwareLogo} alt="boltware" style={{ width: "50%" }}></img></div>
                            <a href="https://boltware.in" rel="noreferrer" className="tx-12" target="_blank">www.boltware.in</a>
                        </div>
                    </div>
                </div>

            </div>
           

        </div>
    );
};

export default Poolings;



